import Vue from 'vue';
import { Tweezing, tweezerHelper } from 'vue-tweezing';
import Tweezer from 'tweezer.js';

Vue.use(Tweezing, {
  tweezer: tweezerHelper(Tweezer),
});
